import AccountProfilePage from '@/pages/account/AccountProfilePage';
import NoteCreatePage from '@/pages/note/NoteCreatePage';
import NotePage from '@/pages/note/NotePage';
import CreatePlanPage from '@/pages/plan/CreatePlanPage';
import DetailPlanPage from '@/pages/plan/DetailPlanPage';
import PlanPage from '@/pages/plan/PlanPage';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ROUTE_PATH } from './paths';
import NoteEditPage from '@/pages/note/NoteEditPage';
import NoteArticlePage from '@/pages/note/NoteArticlePage';

const LoginPage = lazy(() => import('@/pages/auth/LoginPage'));

// Account
const AccountPage = lazy(() => import('@/pages/account/AccountPage'));
const AccountCreatePage = lazy(() => import('@/pages/account/AccountCreatePage'));
const AccountEditPage = lazy(() => import('@/pages/account/AccountEditPage'));

// Client
const ClientPage = lazy(() => import('@/pages/client/ClientPage'));
const ClientCreatePage = lazy(() => import('@/pages/client/ClientCreatePage'));
const ClientEditPage = lazy(() => import('@/pages/client/ClientEditPage'));
const SalonCreatePage = lazy(() => import('@/pages/client/salon/SalonCreatePage'));
const SalonEditPage = lazy(() => import('@/pages/client/salon/SalonEditPage'));

// Account
const accountRoutes: RouteObject[] = [
  {
    path: ROUTE_PATH.HOME,
    element: <AccountPage />,
  },
  {
    path: ROUTE_PATH.ACCOUNT,
    element: <AccountPage />,
  },
  {
    path: ROUTE_PATH.ACCOUNT_CREATE,
    element: <AccountCreatePage />,
  },
  {
    path: ROUTE_PATH.ACCOUNT_EDIT,
    element: <AccountEditPage />,
  },
  {
    path: ROUTE_PATH.PROFILE,
    element: <AccountProfilePage />,
  },
];

const adminRoutes: RouteObject[] = [
  {
    path: ROUTE_PATH.ADMIN,
    element: <AccountPage />,
  },
  {
    path: ROUTE_PATH.ADMIN_CREATE,
    element: <AccountCreatePage />,
  },
  {
    path: ROUTE_PATH.ADMIN_EDIT,
    element: <AccountEditPage />,
  },
];

// Client
const clientRoutes: RouteObject[] = [
  {
    path: ROUTE_PATH.CLIENT,
    element: <ClientPage />,
  },
  {
    path: ROUTE_PATH.CLIENT_CREATE,
    element: <ClientCreatePage />,
  },
  {
    path: ROUTE_PATH.CLIENT_EDIT,
    element: <ClientEditPage />,
  },
  {
    path: ROUTE_PATH.SALON_CREATE,
    element: <SalonCreatePage />,
  },
  {
    path: ROUTE_PATH.SALON_EDIT,
    element: <SalonEditPage />,
  },
];

const noteRoutes: RouteObject[] = [
  {
    path: ROUTE_PATH.NOTE,
    element: <NotePage />,
  },
  {
    path: ROUTE_PATH.NOTE_CREATE,
    element: <NoteCreatePage />,
  },
  {
    path: ROUTE_PATH.NOTE_EDIT,
    element: <NoteEditPage />,
  },
  {
    path: ROUTE_PATH.NOTE_ALLARTICLE,
    element: <NoteArticlePage />,
  },
];

const planRoutes: RouteObject[] = [
  {
    path: ROUTE_PATH.PLAN,
    element: <PlanPage />,
  },
  {
    path: ROUTE_PATH.PLAN_CREATE,
    element: <CreatePlanPage />,
  },
  {
    path: ROUTE_PATH.PLAN_DETAIL,
    element: <DetailPlanPage />,
  },
  {
    path: ROUTE_PATH.PLAN_EDIT,
    element: <CreatePlanPage />,
  },
];

const adminPrivateRoutes: RouteObject[] = [
  ...accountRoutes,
  ...adminRoutes,
  ...clientRoutes,
  ...noteRoutes,
  ...planRoutes,
];

const adminPublicRoutes: RouteObject[] = [
  {
    path: ROUTE_PATH.LOGIN,
    element: <LoginPage />,
  },
];

export { adminPrivateRoutes, adminPublicRoutes };
